import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';

@Injectable()
export class BugfixWA18396Interceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.responseType === 'json') {
      req = req.clone({responseType: 'text'});

      return next.handle(req).map(response => {
        if (response instanceof HttpResponse) {
          response = response.clone<any>({body: JSON.parse(response.body)});
        }

        return response;
      });
    }

    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/http/bugfix.interceptor.ts